import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import FooterEl from "../Footer/FooterEl";
import whatsapp from "../../Images/whatsapp.png";

import Header from "../header/Header";
const ContactUs = () => {
  return (
    <>
      <Header />
      <div className="headLine">
        <p className="textHeadline">Contact Us</p>
        <div className="content">
          <p className="text">
            <strong>Last Updated: 29 May, 2025</strong>
            <br></br>
            <br></br>
            <strong> Contact Us:</strong>
            <br></br>
            Any questions or clarifications with respect to this Privacy Policy
            <br></br>
            or any complaints, comments, concerns or feedback can be sent to Us
            by normal/physical mail addressed to or by online whatsApp and Email
            us:
            <br></br>
            <h4>
              Attn: Shmania Games Private Limited,
              <br></br>
              40/45 Shiv Shakti Nagar Meerut,
              <br></br>250002
              <br></br>
              Uttar Pradesh, India.
            </h4>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <img
                src={whatsapp}
                style={{ borderRadius: "10px", padding: 3 }}
                alt="Logo"
                width={30}
                height={30}
              />
              <h3>+91 7217253066 (only whatsApp)</h3>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <h3>Email : Shmania.games@gmail.com</h3>
            </div>
          </p>
        </div>
      </div>
      <FooterEl />
    </>
  );
};

export default ContactUs;
